
import { ProducerSelect } from "../ProducerSelect";
import { PolicyTypeSelect } from "../PolicyTypeSelect";
import { PolicyLineSelect } from "../PolicyLineSelect";
import { CarrierSelect } from "../CarrierSelect";
import { PolicyAcquisitionField } from "./PolicyAcquisitionField";
import { BasicPolicyFieldsProps } from "../types/fields";

export const BasicPolicyFields = ({
  producer,
  policyType,
  insuranceCarrier,
  policyLine,
  policyAcquisitionType,
  onProducerChange,
  onProducerNameChange, // Added producer name change handler
  onPolicyTypeChange,
  onInsuranceCarrierChange,
  onPolicyLineChange,
  onPolicyAcquisitionTypeChange,
}: BasicPolicyFieldsProps) => {
  console.log("BasicPolicyFields rendering with:", { 
    producer, 
    policyType, 
    policyLine, 
    insuranceCarrier 
  });

  return (
    <div className="space-y-4">
      <ProducerSelect value={producer} onChange={onProducerChange} onProducerNameChange={onProducerNameChange} />
      <PolicyAcquisitionField 
        value={policyAcquisitionType} 
        onValueChange={onPolicyAcquisitionTypeChange} 
      />
      <PolicyLineSelect 
        value={policyLine} 
        onValueChange={onPolicyLineChange}
        policyType={policyType}
      />
      <PolicyTypeSelect 
        value={policyType} 
        onChange={onPolicyTypeChange}
        policyLine={policyLine}
      />
      <CarrierSelect value={insuranceCarrier} onValueChange={onInsuranceCarrierChange} />
    </div>
  );
};
